import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * El módulo "Envíos" (página Amazon.tsx) se alimenta de Order Desk multi-store.
 * Está disponible cuando hay al menos un store enabled en orderdesk_stores.
 *
 * NOTA: la tabla orderdesk_stores tiene RLS restringida a superadmin para no
 * filtrar credenciales (api_key). Usamos la vista pública orderdesk_stores_public
 * que expone solo metadatos (id, name, store_id, client_id, enabled).
 */
export const useAmazonModule = (userId: string | undefined) => {
  const { data, isLoading } = useQuery<{ available: boolean }>({
    queryKey: ["amazonModuleAvailable", userId],
    queryFn: async () => {
      if (!userId) return { available: false };

      // Vista de metadatos (sin api_key): legible por cualquier autenticado,
      // a diferencia de la tabla orderdesk_stores (RLS solo superadmin).
      const { count, error } = await (supabase as any)
        .from("orderdesk_stores_public")
        .select("id", { count: "exact", head: true })
        .eq("enabled", true);

      if (error) return { available: false };
      return { available: (count ?? 0) > 0 };
    },
    enabled: !!userId,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });

  return {
    available: data?.available ?? false,
    amazonClientIds: [] as string[],
    loading: isLoading,
  };
};
